export default __webpack_public_path__ + "static/trace-18501d48a724cf4521d71f035b5a8d4a.png";